import React from 'react';
import { RouteProps } from 'react-router-dom';
import DefaultAside from '../pages/_layout/_asides/DefaultAside';

const asides: RouteProps[] = [
	// {path:"/", element:<Navigate to="/auth-pages/login"/>},
	{ path: 'auth-pages/login', element: null },
	{ path: '/auth/callback', element: null },
	{ path: '*', element: <DefaultAside /> },
];

export default asides;
